import React from "react";
import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Tooltip,
} from "@mui/material";
import { EXTRACTION_URL } from "../helpers/variables";
import { Science } from "@mui/icons-material";

const ReportListItems = ({ reports, selectedReport, setSelectedReport }) => {
  const sendToPDFPlayground = (report) => {
    const input = document.createElement("input");
    input.type = "file";
    input.onchange = (e) => {
      const files = Array.from(e.target.files);
      if (files.length === 0) return;

      // Defer form creation and submission to allow the file chooser to fully settle
      setTimeout(() => {
        const form = document.createElement("form");
        form.action = `${EXTRACTION_URL}/pdf_playground`;
        form.method = "POST";
        form.enctype = "multipart/form-data";
        form.target = "_blank";

        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.name = "upload_file";

        // Manually add the selected file using DataTransfer workaround
        const dt = new DataTransfer();
        dt.items.add(files[0]);
        fileInput.files = dt.files;

        const pmsInput = document.createElement("input");
        pmsInput.type = "hidden";
        pmsInput.name = "report_id";
        pmsInput.value = report._id;

        form.appendChild(fileInput);
        form.appendChild(pmsInput);
        document.body.appendChild(form);

        form.submit();
        document.body.removeChild(form);
      }, 0); // Defer to next tick
    };
    input.click();
  };

  return (
    <>
      {reports.map((report, index) => (
        <Tooltip
          key={index}
          title={
            report.alias_names.length > 0 ? report.alias_names.join(", ") : ""
          }
          open={report.alias_names.length > 0 ? undefined : false}
          arrow
        >
          <ListItem
            disablePadding
            secondaryAction={
              <Tooltip title={report.pipeline} arrow>
                <IconButton
                  onClick={() => sendToPDFPlayground(report)}
                  disabled={report.pipeline === "ocr2table"}
                >
                  <Science />
                </IconButton>
              </Tooltip>
            }
          >
            <ListItemButton
              selected={report._id === selectedReport?._id}
              onClick={() => setSelectedReport(report)}
            >
              <ListItemText
                primary={report.name || "No head"}
                secondary={
                  <Stack>
                    {`Configs: ${report.configs.length}`}
                    <br />
                    {`Date Position: ${report.date_position}`}
                  </Stack>
                }
                slotProps={{ secondary: { component: "div" } }}
              />
            </ListItemButton>
          </ListItem>
        </Tooltip>
      ))}
    </>
  );
};

export default ReportListItems;
